<template>
  <div class="container">
    <input v-model="email" type="text" name="username" placeholder="Email"/>
    <input v-model="password" type="password" name="password" placeholder="Password"/>
    <button @click="login">Login</button>
  </div>
</template>

<script>
import {auth} from '../firebase/firebaseConfig'
export default {
  name: 'Login',
  props: {
    msg: String
  },
  mounted() {},
  data: function (){
    return {
      email: '',
      password: '',
      username: ''
    }
  },
  methods: {
    updateUsername: function() {
      auth.currentUser.updateProfile({
        displayName: this.username
      }).then(function() {
      }).catch(function(error){
        console.log('badness', error)
      })
    },
    login: function() {
      let vm = this
      auth.signInWithEmailAndPassword(this.email, this.password).then(
        function() {
          vm.$router.replace('admin')
        },
        function(err) {
          console.log('aww ', err)
        }
      )
    }
  },
  computed: {
    masks () {
      return this.$store.getters.getMasks
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.container {
  width: 80%;
  display: block;
  padding: 20px;
  margin: auto;
}
input {
  display: inline-block;
  margin: 10px auto;
  padding: 20px;
  width: 280px;
}
button {
  width: 100%;
  margin: 10px auto;
  border-radius: 5px;
  display: block;
  padding: 20px;
  background: #e9c46a;
  color: #264653;
  font-weight: bold;
  box-shadow: 0 8px 6px -6px black;
  cursor: pointer;
}

</style>
